import axiosInstance from '../utils/axios';
import { useConfig } from '../context/ConfigContext';

// Common Summernote helpers for image upload
export const uploadSummernoteImage = async (file, pathKey, linkMap) => {
  const formData = new FormData();
  formData.append('addFile[]', file);
  formData.append('path', pathKey);
  const res = await axiosInstance.post('/file/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  const result = res.data;

  if (!result.success) {
    throw new Error(result.message || 'Image upload failed');
  }
  const filename = result.data?.[0];
  const baseUrl = linkMap?.[pathKey];
  if (!baseUrl) throw new Error(`No upload path configured for ${pathKey}`);
  const url = `${baseUrl}${filename}`;
  return { filename, url };
};

// Hook-based helper for React components
export const useSummernoteImageUpload = () => {
  const { linkMap } = useConfig();
  
  const uploadImage = async (file, pathKey) => {
    return uploadSummernoteImage(file, pathKey, linkMap);
  };
  
  return { uploadImage };
};
